import { Flex, GridItem, IconButton } from "@chakra-ui/react";
import { Fragment } from "react";
import { FaPen, FaTrash } from "react-icons/fa";
import { NUMBER_OF_ACTION_COLS, NUMBER_OF_STATIC_COLS } from "./ConsumptionsGrid";
import { CONSUMPTION_ITEMS, MEASURES } from "../../../../../OrganizationQuestionnaire/helpers";
import { EsgLabel } from "../../../../../../components/Forms";
import { SCOPES } from "../../helpers";

function ConsumptionsGridItems({
                                 consumptionTypes, items, handleEditItem, handleDeleteItem,
                                 scope, consumptionTypesAttr, countries, isPreview
                               }) {
  const getConsumptionTypeValue = (consumptionTypesAttr, id) => {
    const type = consumptionTypesAttr.toLowerCase().includes("stationary") ||
    consumptionTypesAttr.toLowerCase().includes("mobile") ? "stationaryMobileTypes" :
      consumptionTypesAttr.toLowerCase().includes("refrigerant") ? "refrigerantTypes" : "";
    const consumptionType = consumptionTypes[type]?.find(el => el.id === id) ?? "";
    return CONSUMPTION_ITEMS[consumptionType?.code] ?? consumptionType?.name ?? "";
  };

  const getMeasureValue = (consumptionTypeId, id) => {
    const measure = consumptionTypes.measures.find(measure =>
      measure.consumptionTypeId === parseInt(consumptionTypeId))?.measures
      .find(measure => measure.id === parseInt(id));
    return MEASURES[measure?.code] ?? measure?.name ?? "";
  };

  const getElectricityMeasureValue = (electricityType, id) => {
    let measure = consumptionTypes.measures.find(measure =>
      measure.electricityType === electricityType)?.measures
      .find(measure => measure.id === parseInt(id));
    return MEASURES[measure?.code] ?? measure?.name ?? "";
  };

  return (
    <Fragment>
      {items && items.map(field => {
        const gridItems = [];

        if (scope === SCOPES.SCOPE_ONE) {
          // Adding consumption type grid item
          const consumptionTypeValue = getConsumptionTypeValue(consumptionTypesAttr, field.consumptionType);
          const consumptionTypeItem = (
            <EsgLabel overflow="hidden" text={consumptionTypeValue} title={consumptionTypeValue} />
          );
          gridItems.push(consumptionTypeItem);
        } else if (scope === SCOPES.SCOPE_TWO) {
          // Adding country grid item
          const countryValue = countries?.find(country => country.id === field.countryId)?.name ?? field.countryId;
          const countryItem = (
            <EsgLabel overflow="hidden" text={countryValue} title={countryValue} />
          );
          gridItems.push(countryItem);

          // Adding electricity type grid item
          const electricityTypeValue = CONSUMPTION_ITEMS[field.electricityType] ?? field.electricityType;
          const electricityTypeItem = (
            <EsgLabel overflow="hidden" text={electricityTypeValue} title={electricityTypeValue} />
          );
          gridItems.push(electricityTypeItem);
        }


        // Adding consumption value grid item
        const consumptionValue = field.consumptionValue ?? "";
        const consumptionValueItem = (
          <EsgLabel overflow="hidden" text={consumptionValue} title={consumptionValue} />
        );
        gridItems.push(consumptionValueItem);

        // Adding consumption measure grid item
        let consumptionMeasureValue;
        if (scope === SCOPES.SCOPE_ONE) {
          consumptionMeasureValue = getMeasureValue(field.consumptionType, field.consumptionMeasure);
        } else {
          consumptionMeasureValue = getElectricityMeasureValue(field.electricityType, field.consumptionMeasure);
        }
        const consumptionMeasureItem = (
          <EsgLabel overflow="hidden" text={consumptionMeasureValue} title={consumptionMeasureValue} />
        );
        gridItems.push(consumptionMeasureItem);

        if (!isPreview) {
          // Adding row actions buttons in case if it's not in preview mode
          gridItems.push(<Flex>
            <IconButton
              type="button"
              icon={<FaPen size="16" />}
              width="100%"
              variant="ghost"
              color={"esg_green"}
              onClick={() => handleEditItem(field)}
            />
            <IconButton
              type="button"
              icon={<FaTrash size="16" />}
              width="100%"
              variant="ghost"
              color={"esg_red"}
              onClick={() => handleDeleteItem(field)}
            />
          </Flex>);
        }

        return gridItems.map((gridItem, gridItemIndex) => {
          // Total number of columns is sum of static columns and action column (if it's not in preview)
          const numberOfColumns = (NUMBER_OF_STATIC_COLS + (scope === SCOPES.SCOPE_TWO ? 1 : 0)) +
            (!isPreview ? NUMBER_OF_ACTION_COLS : 0);

          return <GridItem
            key={`${gridItemIndex}-${scope === SCOPES.SCOPE_ONE ? consumptionTypesAttr : "indirect"}`}
            borderWidth={"1px"}
            pl="4" pr="4" pt="2" pb="2"
            display="flex"
            alignItems="center"
            colSpan={isPreview ? 2 : gridItemIndex === numberOfColumns - 1 ? 1 : 2}
          >
            {gridItem}
          </GridItem>;
        });
      })}
    </Fragment>
  );
}

export default ConsumptionsGridItems;